@if (data !== null) {
<div class="row px-3 px-lg-0">
    <div class="col-12 col-sm-6">
        <select class="custom-select border-light2 mb-1" [(ngModel)]="seasonId" (change)="onSeasonChange($event)">
            @for (s of data.seasons; track $index) {
            <option [value]="s.season.id">
                {{ s.season.name }}
            </option>
            }
        </select>
    </div>
    <div class="col-12 col-sm-6">
        <select
            class="custom-select border-light2 mb-1"
            [(ngModel)]="subtournamentId"
            (change)="onSubtournamentChange($event)"
        >
            @for (s of selectedSeason?.subtournaments; track $index) {
            <option [value]="s.id">
                {{ s.name }}
            </option>
            }
        </select>
    </div>
</div>
<h4 class="head mt-3 ml-2 ml-xl-0">{{ 'web.faceoffs' | translate }} {{ seasonName }}, {{ subtournamentName }}</h4>
@for (playerFaceoffs of data.players; track $index) {
<div class="d-flex table-scrollable mb-3">
    <table class="table-scrollable__data__table" data-cy="app-table-right-data">
        <thead>
            <tr>
                <th class="table-scrollable__table-th text-center"><i class="fas fa-table"></i></th>
                @for (grp of groups; track $index) {
                <th class="table-scrollable__table-th text-center" [colSpan]="values.length">
                    {{ 'web.faceoffs_' + grp | translate }}
                </th>
                }
            </tr>
            @for (v of values; track $index; let isLast = $last) {
            <tr>
                <th class="table-scrollable__table-th">
                    {{ 'web.faceoffs_' + v | translate }}
                </th>
                @for (grp of groups; track $index) {
                <td class="table-scrollable__table-th text-center" [colSpan]="values.length">
                    {{ playerFaceoffs?.faceoffs?.[grp]?.[v] ?? 0 }}
                </td>
                }
            </tr>
            }
        </thead>
    </table>
</div>
} } @else {
<app-placeholder-table></app-placeholder-table>
}
